<proffeo-ui-dialog
  [title]="task()?.project() ? '' : (modalTitle | translate)"
  [hideDefaultTitle]="!!task()?.project()"
>
  @if (task()?.project(); as project) {
    <div
      dialog-header
      class="min-w-0"
    >
      <div class="truncate font-semibold">{{ project.name }}</div>
      <div class="truncate text-sm">{{ task()?.name }}</div>
    </div>
  }

  <div class="flex flex-col">
    <!-- Time reporting type selection -->
    <ng-template #modeSwitch>
      @if (!onlyTimerMode()) {
        <div class="flex items-center justify-center gap-2">
          <div class="artbygg-col-xxs"></div>

          @if (!isManualHoursType()) {
            <proffeo-ui-choice-group
              (valueChange)="onTimeReportingTypeChange($event)"
              [value]="selectedTimeReportingType()"
              [options]="reportingTypeOptions()"
              [columns]="reportingTypeColumns()"
              class="mx-auto max-w-xs"
            />
          }

          <!-- Minute step menu -->
          @if (isManualHoursType() || selectedTimeReportingType() !== TimeReportingType.TIMER) {
            <div class="artbygg-col-xxs items-start">
              <mat-icon
                [matMenuTriggerFor]="minuteMenu"
                fontIcon="settings"
                class="cursor-pointer icon-disabled"
              />
              <mat-menu #minuteMenu="matMenu">
                <button
                  mat-menu-item
                  disabled
                >
                  {{ 'minute-step-menu-description' | translate }}
                </button>
                @for (step of minuteSteps(); track step) {
                  <button
                    (click)="onMinuteStepChange(step)"
                    mat-menu-item
                  >
                    {{ step }}
                    {{
                      step === 1 ? ('minute-step-menu-minute' | translate) : ('minute-step-menu-minutes' | translate)
                    }}
                  </button>
                }
              </mat-menu>
            </div>
          }
        </div>
      }
    </ng-template>

    <!-- TIMER MODE -->
    @if (selectedTimeReportingType() === TimeReportingType.TIMER && !isManualHoursType()) {
      <ng-container [ngTemplateOutlet]="modeSwitch" />

      <div class="flex items-center justify-center py-6">
        <proffeo-task-timer
          (timerStarted)="startTimer()"
          [mode]="taskTimerMode.column"
          [taskTimer]="activeTimer()"
          [iconSize]="'large'"
        ></proffeo-task-timer>
      </div>

      @if (!activeTimer()?.isStarted) {
        <div class="flex justify-center py-2">
          <span class="text-xl font-semibold text-proffeo-muted">
            {{ 'time-reports-form-modal-start-timer' | translate }}
          </span>
        </div>
      } @else {
        <form [formRoot]="form">
          <proffeo-ui-textarea
            [formField]="form.comment"
            [autosize]="true"
            [minRows]="3"
            [maxRows]="6"
            errorMessage="errors.required"
            placeholder="time-reports-comments-type-your-message"
            class="w-full"
          />

          <div class="mt-3 flex justify-center">
            <proffeo-ui-button
              (clicked)="stopTimer()"
              variant="accent"
              text="time-reports-form-modal-stop-timer"
            ></proffeo-ui-button>
          </div>
        </form>
      }
    } @else {
      <!-- MANUAL / RANGE MODE - show full form -->
      <proffeo-time-report-form
        (manualHoursTypeLeft)="onManualHoursTypeLeft()"
        [allowSelectUser]="canSelectReportUser()"
        [form]="form"
        [selectUser]="selectUser"
        [selectedValue]="selectedTimeReportingType()"
        [timeReport]="timeReport"
        [task]="task()"
        [currentMinuteStep]="currentMinuteStep"
        [includeManualHoursType]="true"
        [draftStartedAt]="draftStartedAt()"
      >
        <div mode-switch>
          <ng-container [ngTemplateOutlet]="modeSwitch" />
        </div>
      </proffeo-time-report-form>

      <!-- REGISTRATION DETAILS (read-only) -->
      <proffeo-time-registration-details [timeReport]="timeReport"></proffeo-time-registration-details>
    }
  </div>

  @if (selectedTimeReportingType() !== TimeReportingType.TIMER || isManualHoursType()) {
    <div
      dialog-actions
      class="flex w-full justify-center gap-12"
    >
      <proffeo-ui-button
        (clicked)="saveTimeReport(false)"
        [disabled]="form().submitting()"
        text="time-reports-form-modal-save"
      ></proffeo-ui-button>
      <proffeo-ui-button
        (clicked)="saveTimeReport(true)"
        [disabled]="form().submitting()"
        variant="accent"
        text="time-reports-form-modal-save-and-exit"
      ></proffeo-ui-button>
    </div>
  }
</proffeo-ui-dialog>
